import { useRef, useState } from "react";
import { useComment } from "../../contexts/CommentContext";
import { Button } from "../../design/button";
import CommentListItem from "../CommentListItem/CommentListItem";
import SlateTextArea, { SlateEditorRef } from "../SlateTextArea/SlateTextArea";
import { Descendant } from "slate";
import { getPlainText } from "../../utils/slate";

interface AdminCommentListProps {
  matterId?: string;
  clientId?: string;
  matterTypeId?: string;
  intakeId?: string;
}

const AdminCommentList = ({
  matterId,
  clientId,
  matterTypeId,
  intakeId,
}: AdminCommentListProps) => {
  const editorRef = useRef<SlateEditorRef | null>(null);
  const { createComment, comments } = useComment();
  const [comment, setComment] = useState<Descendant[] | null>(null);
  const [teamMemberIds, setTeamMemberIds] = useState<string[]>([]);

  const handleAddComment = async () => {
    try {
      await createComment({
        content: JSON.stringify(comment),
        matter: matterId,
        parentType:
          (clientId && "User") || (matterTypeId && "MatterType") || "Intake",
        parent: clientId || matterTypeId || intakeId!,
        comments: [],
      });

      setComment(null);
      editorRef.current?.resetEditor();
      setTeamMemberIds([]);
    } catch (error) {
      console.error("Error adding comment:", error);
    }
  };

  const handleTextAreaChange = (descendents: Descendant[]) => {
    setComment(descendents);
  };

  const filteredComments = comments?.filter((comment) => {
    return (
      (matterId && comment.matter === matterId) ||
      (clientId && comment.parent === clientId) ||
      (matterTypeId && comment.parent === matterTypeId) ||
      (intakeId && comment.parent === intakeId)
    );
  });

  return (
    <div>
      <div className="my-4">
        <SlateTextArea
          id="comment"
          placeholder="Type @ for user mention, / for commands, or # for file mention..."
          ref={editorRef}
          initialValue={comment ?? undefined}
          onChange={handleTextAreaChange}
        />
        <Button
          type="button"
          className="w-full py-2 mt-2 text-white bg-blue-500 rounded-md"
          onClick={handleAddComment}
          disabled={getPlainText(comment ?? []) === ""}
        >
          Add Comment
        </Button>
      </div>
      <div>
        {filteredComments?.map((comment) => (
          <CommentListItem key={comment._id} comment={comment} />
        ))}
      </div>
    </div>
  );
};

export default AdminCommentList;
